<template>
    <div>
        <despesa v-if="mostrarDespesa"
            :despesa="despesa"
            :temAcessoDetalharItem="$temAcessoView('DESP-GERAIS-DEMAN-00')"
            :temAcessoHistorico="$temAcessoView('DESP-GERAIS-DEMAN-00')"
            :rotaDetalharItem="'DespesasGerais_Demandantes_ItensDespesa_Detalhar'"
            :temAcessoAnexos="$temAcessoView('DESP-GERAIS-DEMAN-00')"
            :mostrarAnexos="mostrarAnexos"
            :anexos="anexos"
            @mostrarAnexos="obterAnexos()"
            @baixarAnexo="baixarAnexo($event)"
            @fecharAnexos="fecharAnexos()"
            :servicos="obterServicos()"
        >
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
                <btn-reprovar
                    :despesa="despesa"
                    @obterDespesa="obterDespesa()"
                ></btn-reprovar>
                <b-button
                    v-if="$temAcessoView('DESP-GERAIS-DEMAN-01') && statusAprovacao"
                    class="ml-2"
                    variant="primary"
                    :despesa="despesa"
                    @click.stop="abrirModal()"
                ><i class="fa fa-check-circle"></i> Aprovar
                </b-button>
            </template>
        </despesa>
        <router-view></router-view>

        <b-modal v-model="mostrarModal" size="lg">
            <div slot="modal-title">
                Avaliação Despesa - {{ despesa.sequencial }}
            </div>
            <b-row>
                <b-col sm="12">

                    <despesa-pesquisa
                        class="mt-2"
                        v-if="despesa"
                        v-model="avaliacoes"
                        :despesa="despesa"
                        @atualizarAvaliacao="atualizarAvaliacao($event)"
                    >
                    </despesa-pesquisa>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Fechar</b-button
                >
                <b-button
                    class="ml-2"
                    variant="primary"
                    @click.stop="confirmarAprovacao()"
                ><i class="fa fa-check-circle"></i>
                Aprovar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Despesa from '@/app/despesasgerais/componentes/despesas/Despesa.vue';
import { StatusDespesa } from '../../componentes/despesas/StatusDespesa'
import DespesasServicos from './DespesasServicos'
import DespesasAnexosServicos from './DespesasAnexosServicos'
import DespesaPesquisa from './DespesaPesquisa.vue';
import BtnReprovar from './BtnReprovar.vue';
import { StatusComprometimento } from '../../componentes/despesas/StatusComprometimento'


export default {

    components: {
        Despesa,
        BtnReprovar,
        DespesaPesquisa
    },

    data() {
        return {
            despesa: null,
            mostrarAnexos: false,
            anexos: [],
            avaliacoes: [],
            mostrarModal: false,
            problema: null,
        }
    },

    methods: {
        obterDespesa() {
            this.$store.dispatch('addRequest')
            DespesasServicos.obterPorId(this.$route.params.despesaId).then(response => {
                if (response) {
                    if (response.success) {
                        this.despesa = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarAprovacao() {
            this.$swal({
                title: 'Aprovar Despesa',
                html: `Confirma a aprovação da despesa?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.aprovar()
                }
            })
        },
        atualizarAvaliacao(avaliacao) {
            this.avaliacoes = avaliacao;
        },
        aprovar() {
            this.$store.dispatch('addRequest')
            let avaliacoesDto = {
                AvaliacaoDto: this.avaliacoes.avaliacoes,
            };
            DespesasServicos.aprovar(this.despesa.despesaId, avaliacoesDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Despesa aprovada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterDespesa()
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
                this.fecharModal()
            });
        },

        obterAnexos() {
            this.$store.dispatch('addRequest')
            DespesasAnexosServicos.obterAnexos(this.$route.params.despesaId).then(response => {
                if (response) {
                    if (response.success) {
                        this.anexos = response.data
                        this.mostrarAnexos = true
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        baixarAnexo(anexo) {
            DespesasAnexosServicos.baixarAnexo(anexo).then(response => {
                if (response) {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao realizar download do anexo!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                anexo.nomeArquivoOriginal
                            )
                        }
                    }
                }
            })
        },

        fecharAnexos() {
            this.mostrarAnexos = false
        },

        abrirModal() {
            this.avaliacoes = { avaliacoes: this.despesa.avaliacoes }
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        obterServicos() {
            return DespesasServicos
        }
    },

    created() {
        this.obterDespesa()
    },

    computed: {
        mostrarDespesa() {
            return this.$route.name === 'DespesasGerais_Demandantes_Despesas_Detalhar'

        },

        statusAprovacao() {
            return this.despesa != null
                && this.despesa.statusId == StatusDespesa.AGUARDANDO_APROVACAO_DEMANDANTE
                && this.despesa.statusComprometimentoId == StatusComprometimento.COMPROMETIDO
        }
    },
}
</script>
